export default __webpack_public_path__ + "static/media/IMG_1970.99729e6a.JPG";